export const CATEGORY_CONGRATS_SCREEN = "congrats_screen";
export const CATEGORY_MERKEN_BUTTON = "merken_button";
export const CATEGORY_TOOLTIP = "tooltip";
export const CATEGORY_TOOLTIP_V1 = "tooltip_v1";
export const CATEGORY_WIZARD_V1 = "wizard_v1";
export const CATEGORY_ONBOARDING_V1 = "onboarding_v1";
export const SIGNUP_BUTTON = "signup_button";
